module.exports = __webpack_public_path__ + "img/image 19.ef5758c7.png";